import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {PARTYCATEGORY, PARTYROLE} from "party/partyDomain";
import {loc} from "core/common/config/locales";

const gridLocation = 'partySalesReps';

@observer
export default class SalesRepList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.party;
  static title = loc.i18n`Sales Representative`;
  static icon = 'child';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(params) {
    console.log("SalesRepList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }


  render() {
    let {params, query} = this.props;

    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                         multiUpdateSecurable={SECURABLE.partyGridUpdate} >
        <ZzFlatButtonRoute onGridToolbar routeName="partyDetail" params={{id: 'new'}} query={{partyCategory: PARTYCATEGORY.PE, roles:PARTYROLE.SALESREP_ROLE}} label="New Sales Rep" permission={PERMISSION.New}/>
      </GridCompConnected>
    );
  }

}






// WEBPACK FOOTER //
// ./src/party/page/salesRepList.tsx